<div class="wrapper">
    <!-- start .row -->
    <div class="row">
        <div class="col-sm-12 wtw-hero-image">
            <img id="BGprincipal" class="img-responsive" src="./assets/global/images/cabeceras/bg_admin_auditoria.jpg">
            <h1 class="wtw-bg-black col-lg-5" style="margin-left: 15px">Administración</h1>
        </div>
    </div>
    <!-- end .row -->

    <div class="container-fluid">

        <!-- Page-Title -->
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <div class="btn-group pull-right">
                        <ol class="breadcrumb hide-phone p-0 m-0">
                            <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                            <li class="breadcrumb-item"><a href="#">Administración</a></li>
                            <li class="breadcrumb-item"><a href="#">Paramétricas</a></li>
                            <li class="breadcrumb-item"><a href="#">Contacto Aseguradoras</a></li>
                        </ol>
                    </div>
                    <h4 class="page-title">Administración Paramétricas</h4>
                </div>
            </div>
        </div>
        <!-- end page title end breadcrumb -->
        <div class="col-lg-12">
            <div class="card-box">
                <h4 class="header-title mb-3">Contacto Aseguradoras</h4>
                <form [formGroup]="formContactoAse">
                    <div class="form-row ">
                        <div class="form-group col-md-4">
                            <label for="userName">Aseguradora<span class="text-danger">*</span></label>
                            <ng-select2 formControlName="idAdmAseguradora" id="select-aseguradora" 
                                [data]="ListAseguradoras" class="form-control">
                            </ng-select2>
                        </div>


                        <div class="form-group col-md-4">
                            <label for="userName">Ramo<span class="text-danger">*</span></label>
                            <ng-select2 formControlName="idAdmRamo" id="select-ramo" 
                                [data]="ListRamos" class="form-control">
                            </ng-select2>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="userName">Ciudad<span class="text-danger">*</span></label>
                            <ng-select2 formControlName="idAdmCiudad" id="select-ciudad" 
                                [data]="ListCiudades" class="form-control">
                            </ng-select2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-4">
                            <label for="userName">Teléfono<span class="text-danger">*</span></label>
                            <input type="text" formControlName="numero" parsley-trigger="change" required
                                class="form-control" id="">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="userName">Línea Nacional<span class="text-danger">*</span></label>
                            <input type="text" formControlName="lineaNacional" parsley-trigger="change" required
                                class="form-control" id="">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="userName">Celular<span class="text-danger">*</span></label>
                            <input type="text" formControlName="celular" parsley-trigger="change" required
                                class="form-control" id="">
                        </div>
                        <div class="actions clearfix">
                            <button type="button" *ngIf="!edit" (click)="onSubmit()"
                                class="btn btn-custom waves-effect waves-light " [disabled]="!formContactoAse.valid">
                                Guardar
                            </button>
                            <button type="button" *ngIf="edit" (click)="update()"
                                class="btn btn-custom waves-effect waves-light">
                                Editar
                            </button>
                            <button type="reset" class="btn btn-light waves-effect m-l-5">
                                Listar Teléfonos
                            </button>
                        </div>
                    </div>

                </form>

            </div>
        </div>


        <div class="row col-lg-12">
            <div class="col-lg-12">
                <div class="card-box table-responsive">
                    <div id="key-table_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                        <div class="row">
                            <div class="col-sm-12">
                                <div style="position: absolute; height: 1px; width: 0px; overflow: hidden;"><input
                                        type="text" tabindex="0"></div>
                                <table class="table table-hover m-0 tickets-list table-actions-bar dt-responsive nowrap"
                                    cellspacing="0" width="100%" id="datatable">
                                    <thead>
                                        <tr>
                                            <th>Aseguradora</th>
                                            <th>Ramo</th>
                                            <th>Ciudad</th>
                                            <th>Teléfono</th>
                                            <th>Línea Nacional</th>
                                            <th>Celular</th>
                                            <th>Modificar</th>
                                            <th>Eliminar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of ListContAsegu">
                                            <td>{{item.nombreAdmAseguradora}}</td>
                                            <td>{{item.nombreAdmRamo}}</td>
                                            <td>{{item.nombreAdmCiudad}}</td>
                                            <td>{{item.numero}}</td>
                                            <td>{{item.lineaNacional}}</td>
                                            <td>{{item.celular}}</td>
                                            <td><a (click)="getAseguradoraToEdit(item.idAdmAseguradoraRamoTelefono)"
                                                    class="btn btn-sm btn-purple"><i class="mdi mdi-pencil"></i></a>
                                            </td>
                                            <td><a (click)="deleteAseguradora(item.idAdmAseguradoraRamoTelefono)"
                                                    class="btn btn-sm btn-danger"><i class="mdi mdi-delete"></i></a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="row">
            <div class="col-lg-12">
                <div class="card-box table-responsive">

                    <div id="key-table_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                        <div class="row">
                            <div class="col-sm-12">
                                <div style="position: absolute; height: 1px; width: 0px; overflow: hidden;"><input
                                        type="text" tabindex="0"></div>
                                <table class="table table-hover m-0  dt-responsive nowrap" cellspacing="0" width="100%"
                                    id="datatable">

                                    <thead>
                                        <tr>
                                            <th>Aseguradora</th>
                                            <th>Ramo</th>
                                            <th>Ciudad</th>
                                            <th>Teléfono</th>
                                            <th>Línea Nacional</th>
                                            <th>Celular</th>
                                            <th>Modificar</th>
                                            <th>Eliminar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of contactoAseService.listContactoAse">
                                            <td>{{item.nombreAdmAseguradora}}</td>
                                            <td>{{item.nombreAdmRamo}}</td>
                                            <td>{{item.nombreAdmCiudad}}</td>
                                            <td>{{item.numero}}</td>
                                            <td>{{item.lineaNacional}}</td>
                                            <td>{{item.celular}}</td>
                                            <td><a (click)="getAseguradoraToEdit(item.idAdmAseguradoraRamoTelefono)"
                                                    class="btn btn-sm btn-purple"><i class="mdi mdi-pencil"></i></a>
                                            </td>
                                            <td><a href="#" class="btn btn-sm btn-danger"><i
                                                        class="mdi mdi-delete"></i></a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>


                </div>

            </div>
        </div> -->

    </div> <!-- end container -->
</div>

<!-- end wrapper -->
<div class="blanco"></div>